<script setup lang="ts">

import Icon from "@/components/UI/Icon.vue";
import {onMounted, ref} from "vue";
import LikeIcon from "@/components/UI/Icon/LikeIcon.vue";

const props = withDefaults(defineProps<{
  color?: string,
  withoutAnimation?: boolean
}>(), {
  color: "#9A9B9C"
})
const step = ref(props.withoutAnimation ? 3 : 1);
const timeout = (timeout: number) => new Promise(resolve => setTimeout(resolve, timeout));
onMounted(async() => {
  await timeout(1500);
  step.value = 2;
  await timeout(1000);
  step.value = 3;
})
</script>

<template>
  <div class="goal-done" :style="{color: color}" :class="{done: step===3}">
    <div v-if="step === 1" class="goal-done__firework">
      <div class="goal-done__firework__spark__left"></div>
      <div class="goal-done__firework__progress">100%</div>
      <div class="goal-done__firework__spark__right"></div>
    </div>
    <div v-if="step === 2" class="goal-done__congratulation">
      <div>
        <LikeIcon class="goal-done__congratulation__icon"/>
      </div>
      <div>Поздравляю!</div>
    </div>
    <div v-if="step === 3" class="goal-done__done">
      <div>
        <Icon name="done" :size="34" color="#FFBA35"/>
      </div>
      <div>Выполнено</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@property --background-color-1 {
  syntax: '<color>';
  initial-value: #FFF;
  inherits: false;
}

@property --background-color-2 {
  syntax: '<color>';
  initial-value: #FFF;
  inherits: false;
}

@keyframes done {
  0% {
    gap: 0;
  }
  100% {
    gap: 10px;
  }
}

@keyframes firework {
  0% {
    transform: translateY(40px) scale(0);
  }
  20% {
    transform: translateY(0px) scale(1.2);
  }
  40% {
    transform: translateY(0px) scale(0.8);
  }
  60% {
    transform: translateY(0px) scale(1.1);
  }
  80% {
    transform: translateY(0px) scale(0.9);
  }
  100% {
    transform: translateY(0px) scale(1);
  }
}


.goal-done {
  font-weight: 500;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  position: relative;
  height: 100%;

  > * {
    z-index: 1;
  }

  &__congratulation {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #F5F5F5;
  }

  &__done {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    gap: 13px;
    animation: done 0.6s;
    font-weight: 500;
    color: #FFBA35;
  }

  &__firework {
    position: relative;
    width: 100%;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__progress {
      font-size: 20px;
      font-weight: 700;
      color: #FFFFFF;
      transform: scale(0);
      animation-delay: 0.2s;
      animation-name: firework;
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }

    &__spark {
      &__left, &__right {
        background-image: url("~@/assets/animation/firework.svg");
        transform: translateY(-50%) scale(0);
        width: 57px;
        height: 110px;
        animation-delay: 0.2s;
        animation-name: firework;
        animation-duration: 1s;
        animation-fill-mode: forwards;
      }

      &__right {
        scale: -1 1;
      }
    }
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    --background-color-1: #FFBA35;
    --background-color-2: #FD9F30;
    background: linear-gradient(91.59deg, var(--background-color-1) 0%, var(--background-color-2) 100%);
  }

  &.done:before {
    --background-color-1: #FFF;
    --background-color-2: #FFF;
  }
}
</style>
